export default {
  //保存
  SAVE: '/jcnapi/videoArea/save',
  //删除
  DEL: '/jcnapi/videoArea/delete',
  GET_LIST: '/jcnapi/videoArea/getList',
  SET_BANNER: '/jcnapi/videoArea/setBanner',
  GET: '/jcnapi/videoArea/getBanner'
}



// WEBPACK FOOTER //
// ./src/data/apiUrl/modules/videoArea/index.js